export default [
  { value: 'Or', name: 'Или' },
  { value: 'Exclude', name: 'Исключая' },
]
